import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state?.sso || initialState;

export const selectSso = createSelector([selectSlice], state => state);
